// extracted by mini-css-extract-plugin
export default {"container":"GameCard_container__+-n0X"};